import { useState, useEffect } from 'react'
import axios from 'axios'
import MyIcon from '../../../components/general/icon'
import AddAlmamaterVisitCategory from './add'
import EditAlmamaterVisitCategory from './edit'
import DeleteAlmamaterVisitCategory from './delete'

export default function AlmamaterVisitCategory() {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [almamaterVisitCategoryList, setAlmamaterVisitCategoryList] = useState([])
  const [propsData, setPropsData] = useState({})
  const [isAddAlmamaterVisitCategoryVisible, setIsAddAlmamaterVisitCategoryVisible] = useState(false)
  const [isEditAlmamaterVisitCategoryVisible, setIsEditAlmamaterVisitCategoryVisible] = useState(false)
  const [isDeleteAlmamaterVisitCategoryVisible, setIsDeleteAlmamaterVisitCategoryVisible] = useState(false)

  const getAlmamaterVisitCategoryList = () => {
    axios.post('/p/almamater_visit/category/list/get', { merchant_oid: merchantOid })
      .then(function (response) {
        if (response.errcode === 0) {
          setAlmamaterVisitCategoryList(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }

  useEffect(() => {
    getAlmamaterVisitCategoryList()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [merchantOid])

  const editAlmamaterVisitCategory = (oid) => {
    setIsEditAlmamaterVisitCategoryVisible(true)
    setPropsData({ oid: oid })
  }

  const deleteAlmamaterVisitCategory = (oid, name) => {
    setIsDeleteAlmamaterVisitCategoryVisible(true)
    setPropsData({ oid: oid, name: name})
  }

  const getStatusColor = (code) => {
    switch (code) {
      case 1:
        return 'orange'
      case 2:
        return 'blue'
      case 3:
        return 'grey'
      default:
        return 'green'
    }
  }

  return (
    <div className="public-page">
      <div className="public-container">
        <div className="public-header">
          <div className="public-title">分类管理</div>
        </div>

        <div className='public-main-style'>
          <div className='public-main-style1'>
            <div className='public-main-style1-add' onClick={() => { setIsAddAlmamaterVisitCategoryVisible(true) }}>
              <div className='public-main-style1-add-icon'>
                <MyIcon name='jiahao' />
              </div>
              <div className='public-main-style1-add-title'>创建新的母校行分类</div>
            </div>

            {almamaterVisitCategoryList.map(item => (
              <div className='public-main-style1-content' key={item.oid} onClick={() => { editAlmamaterVisitCategory(item.oid) }}>
                <div>
                  <div className='public-main-style1-content-title'>
                    <div className='public-main-style1-content-name'>{item.name}</div>
                    <div className='public-main-style1-content-delete' 
                      onClick={(event) => {event.stopPropagation(); deleteAlmamaterVisitCategory(item.oid, item.name)}}>
                      <MyIcon name='huishouzhan' />
                    </div>
                  </div>
                </div>
                <div className='public-main-style1-content-other'>
                  <div className='public-main-style1-content-other-left'>
                    <div style={{width: '7px', height: '7px', borderRadius: '5px', background: getStatusColor(item.status.code)}}></div>
                    {item.status.msg}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {isAddAlmamaterVisitCategoryVisible && <AddAlmamaterVisitCategory
        getAlmamaterVisitCategoryList={getAlmamaterVisitCategoryList} 
        isOpen={isAddAlmamaterVisitCategoryVisible} 
        isCancel={() => { setIsAddAlmamaterVisitCategoryVisible(false) }} 
      />}

      {isEditAlmamaterVisitCategoryVisible && <EditAlmamaterVisitCategory
        data={propsData}
        getAlmamaterVisitCategoryList={getAlmamaterVisitCategoryList}
        isOpen={isEditAlmamaterVisitCategoryVisible}
        isCancel={() => { setIsEditAlmamaterVisitCategoryVisible(false) }}
      />}

      {isDeleteAlmamaterVisitCategoryVisible && <DeleteAlmamaterVisitCategory
        data={propsData}
        getAlmamaterVisitCategoryList={getAlmamaterVisitCategoryList}
        isOpen={isDeleteAlmamaterVisitCategoryVisible}
        isCancel={() => { setIsDeleteAlmamaterVisitCategoryVisible(false) }}
      />}
    </div>
  )
}
